export type MouseFilterOption = {
  value: string;
  label: string;
  keywords?: string[];
};

export type MouseFilterGroup = {
  id: string;
  label: string;
  options: MouseFilterOption[];
};

export const mouseFilterGroups: MouseFilterGroup[] = [
  {
    id: 'brand',
    label: 'Hãng',
    options: [
      { value: 'logitech', label: 'LOGITECH', keywords: ['logitech'] },
      { value: 'razer', label: 'RAZER', keywords: ['razer'] },
      { value: 'steelseries', label: 'STEELSERIES', keywords: ['steelseries'] },
      { value: 'corsair', label: 'CORSAIR', keywords: ['corsair'] },
      { value: 'hyperx', label: 'HYPERX', keywords: ['hyperx'] },
      { value: 'asus', label: 'ASUS', keywords: ['asus', 'rog', 'tuf'] },
      { value: 'msi', label: 'MSI', keywords: ['msi'] },
      { value: 'gigabyte-aorus', label: 'GIGABYTE AORUS', keywords: ['gigabyte', 'aorus'] },
      { value: 'cooler-master', label: 'COOLER MASTER', keywords: ['cooler master'] },
      { value: 'zowie', label: 'ZOWIE', keywords: ['zowie'] },
      { value: 'akko', label: 'AKKO', keywords: ['akko'] },
      { value: 'rapoo', label: 'RAPOO', keywords: ['rapoo'] },
      { value: 'dareu', label: 'DAREU', keywords: ['dareu'] },
      { value: 'e-dra', label: 'E DRA', keywords: ['e-dra', 'edra'] },
      { value: 'alienware', label: 'ALIENWARE', keywords: ['alienware'] },
    ],
  },
  {
    id: 'type',
    label: 'Loại chuột',
    options: [
      { value: 'gaming', label: 'Gaming', keywords: ['gaming'] },
      { value: 'office', label: 'Văn phòng', keywords: ['van phong', 'office'] },
    ],
  },
  {
    id: 'connectivity',
    label: 'Kết nối',
    options: [
      { value: '3mode', label: '3 Mode', keywords: ['3 mode', '3-mode', 'tri-mode'] },
      { value: 'wired', label: 'Có dây', keywords: ['co day', 'wired', 'usb'] },
      {
        value: 'wireless',
        label: 'Wireless',
        keywords: ['wireless', 'khong day', 'bluetooth', '2.4ghz'],
      },
    ],
  },
  {
    id: 'led',
    label: 'Đèn LED',
    options: [
      { value: 'rgb', label: 'LED RGB', keywords: ['rgb'] },
      { value: 'argb', label: 'LED ARGB', keywords: ['argb'] },
      { value: 'single', label: 'LED Đơn', keywords: ['led don', 'single led'] },
      { value: 'none', label: 'Không LED', keywords: ['khong led', 'no led'] },
    ],
  },
  {
    id: 'dpi',
    label: 'Chỉ số DPI',
    options: [
      { value: '400', label: '400 DPI', keywords: ['400 dpi', '400dpi'] },
      { value: '800', label: '800 DPI', keywords: ['800 dpi', '800dpi'] },
      { value: '1000', label: '1000 DPI', keywords: ['1000 dpi', '1000dpi'] },
      { value: '1200', label: '1200 DPI', keywords: ['1200 dpi', '1200dpi'] },
      { value: '1600', label: '1600 DPI', keywords: ['1600 dpi', '1600dpi'] },
      { value: '2000', label: '2000 DPI', keywords: ['2000 dpi', '2000dpi'] },
      { value: '3200', label: '3200 DPI', keywords: ['3200 dpi', '3200dpi'] },
      { value: '4000', label: '4000 DPI', keywords: ['4000 dpi', '4000dpi'] },
      { value: '6400', label: '6400 DPI', keywords: ['6400 dpi', '6400dpi'] },
      { value: '8000', label: '8000 DPI', keywords: ['8000 dpi', '8000dpi'] },
      { value: '12000', label: '12000 DPI', keywords: ['12000 dpi', '12000dpi'] },
      { value: '16000', label: '16000 DPI', keywords: ['16000 dpi', '16000dpi'] },
      { value: '20000', label: '20000 DPI', keywords: ['20000 dpi', '20000dpi'] },
      { value: '26000', label: '20000 DPI', keywords: ['26000 dpi', '26000dpi'] },
      { value: '32000', label: '32000 DPI', keywords: ['32000 dpi', '32000dpi'] },
    ],
  },
];
